<template>
    <div>
        <stuBasicManager></stuBasicManager>
    </div>
</template>

<script>
import stuBasicManager from "page/xSchool/stuManager/stuBasicManager.vue";
export default {
  data(){
      return {}
  },
  components:{
      stuBasicManager
  }
}
</script>

<style>

</style>
